import { registerPropertyManagerSection } from '@/core';
import ReferencePlanePropertySection from '@/components/editor/property-manager/reference/ReferencePlanePropertySection.vue';

registerPropertyManagerSection({
  id: 'datum-plane',
  title: '基准面',
  order: 35,
  component: ReferencePlanePropertySection,
  actions: {
    confirm: true,
    cancel: true,
  },
  isApplicable: (context) => {
    if (context.activeCommand === 'geometry-reference-plane') {
      return true;
    }
    return Boolean(context.referencePlaneActive);
  },
  onConfirm: (context) => {
    context.submitReferencePlane?.();
  },
  onCancel: (context) => {
    context.cancelReferencePlane?.();
  },
});
